export enum champerTemperatureStatuses {
  Unknown = 0,
  INIT = 1,
  ERROR,
  SAFE,
  IN_HEATING,
  IN_COOLING,
  AT_TEMPERATURE,
  STABILIZED,
  AUTOTUNE,
}
